import view from '../../view';
import actionTypes from '../constants/action-types';
import hdrm from '../../hdrm';
import getModifiedGlobals from './get-modified-globals';
import isElementGlobal from '../verifiers/is-element-global';
import isElementDetached from '../verifiers/is-element-detached';
import getGlobalBySource from '../selectors/global-by-source';

const getGlobalsToUpdate = (state, action) => {
  switch (action.type) {
    case view.actionTypes.CHANGE_HTML: {
      return action.payload.globalsToUpdate;
    }

    case view.actionTypes.SYNCHRONIZE_ELEMENT:
    case view.actionTypes.SET_ELEMENT_ATTRIBUTE:
    case view.actionTypes.SET_INLINE_ELEMENT_STYLE:
    case view.actionTypes.REMOVE_ELEMENT_ATTRIBUTE: {
      const { elementId } = action.payload;
      const element = view.accessors.getStaticElement(elementId);

      if (isElementGlobal(elementId) && !isElementDetached(element)) {
        const globalSource = hdrm.accessors.getElementAttribute(elementId, 'src');
        const global = getGlobalBySource(state, globalSource);
        if (!global) return [];
        return [{ id: global.id, source: global.source, elementId }];
      }

      return getModifiedGlobals(state, action);
    }

    case actionTypes.SET_GLOBAL_HTML_AND_AFFECT_HISTORY: {
      return [{ id: action.payload.globalId }];
    }

    default: {
      return getModifiedGlobals(state, action);
    }
  }
};

export default getGlobalsToUpdate;
